module.exports = __webpack_public_path__ + "img/01.c31f5a25.png";